import * as React from "react";

import Value from "./Value";
import { getFieldDef, getFieldNames } from "./wsDefs";
import { getWsById } from "./wsHelpers";

const humanize = require("underscore.string/humanize");
const styles = require("./styles.module.scss");

const EditorPage: React.SFC<any> = ({
  worksheets,
  wsId,
  fieldUpdate,
  setCurrentWsId,
  addWsToParent,
  deleteWsFromParent,
  showChildrenInline,
  showHidden,
  readOnly,
}) => {
  const ws = getWsById(worksheets, wsId);
  if (!ws) {
    throw new Error(`EditorPage failed: cannot find ${wsId}`);
  }

  return (
    <table className={styles.page__list}>
      <tbody>
        {getFieldNames(ws.name).map(field => {
          const fieldDef = getFieldDef(ws.name, field);

          if (fieldDef.hidden && !showHidden) {
            return null; // TODO: jjw: display depending on role (ops versus eng)?
          }
          if (typeof fieldDef.shownIf === "function" && !fieldDef.shownIf(ws.instance)) {
            return null;
          }

          return (
            <tr key={`${wsId}-${field}`} className={styles.page__item}>
              <td className={styles.page__field}>
                <span>{humanize(field)}:</span>
              </td>
              <td className={styles.page__value}>
                <Value
                  worksheets={worksheets}
                  ws={ws}
                  field={field}
                  onUpdate={fieldUpdate}
                  setCurrentWsId={setCurrentWsId}
                  addWsToParent={addWsToParent}
                  deleteWsFromParent={deleteWsFromParent}
                  showChildrenInline={showChildrenInline}
                  showHidden={showHidden}
                  readOnly={readOnly}
                />
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default EditorPage;
